import { useEffect, useState } from "react";
import { Save, TextCursor } from 'lucide-react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, IconButton, Typography } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import Template from "../../template/Template";
import InputLabel from "../../components/Inputs/InputLabel";
import SimpleBackdrop from "../../components/Loading/Simplebackdrop";
import { AlertConfirm, AlertInfo } from "../../components/Alerts/Alert";
import { api } from "../../services/api";

import ModalNovoTexto from "./ModalNovoTexto";

type TextoProps = {
    id_paragrafo: number
    tipo_paragrafo: string
    variavel: string
    paragrafo: string
};

export default function Texto() {
    const [load, setLoad] = useState(false);
    const [expanded, setExpanded] = useState('');
    const [textos, setTextos] = useState<TextoProps[]>([]);
    const [updateText, setUpdateText] = useState(0);
    const [modalNewText, setModalNewText] = useState(false);

    function hanleText(txt: string, index: number) {
        let all = textos;
        all[index].paragrafo = txt;
        setTextos(all);
        setUpdateText(updateText + 1);
    }

    async function handleSaveTexts() {
        setLoad(true);
        try {
            const response = await api.post(`/updateparagrafospadrao`, textos);
            if (response.data && response.data.success) {
                AlertInfo({ icon: 'success', title: 'Dados Gravados' });
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setLoad(false);
    }

    async function handleDelete(id_paragrafo : number) {
        AlertConfirm({title: 'Deletar Paragrafo'}).then(async(res) => {
            if(res.isConfirmed){
                setLoad(true);
                try {
                    const response = await api.delete(`/deleteparagrafopadrao/${id_paragrafo}`);
                    if (response.data && response.data.success) {
                        AlertInfo({ icon: 'success', title: 'Paragrafo Deletado' }).then(() => {
                            loadTexts();
                        });
                    }
                } catch (error) {
                    console.log(error);
                    AlertInfo({ icon: 'error', title: 'Falha na conexão' });
                }
                setLoad(false);
            }
        });
    }

    async function loadTexts() {
        setLoad(true);
        try {
            const response = await api.get(`/paragrafospadrao`);
            if (response.data && response.data[0]) setTextos(response.data);
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setLoad(false);
    }

    useEffect(() => {
        loadTexts();
    }, []);

    return (
        <Template menuActive="Textos">
            <SimpleBackdrop open={load} />
            <ModalNovoTexto
                open={modalNewText}
                setOpen={setModalNewText}
                reload={loadTexts}
            />

            <Grid container spacing={1}>
                <Grid container justifyContent="flex-end" size={12}>
                    <Button
                        variant="contained"
                        startIcon={<TextCursor />}
                        color="primary"
                        onClick={() => setModalNewText(true)}
                    >
                        NOVO TEXTO
                    </Button>
                </Grid>
                <Grid size={12}>
                    {updateText >= 0 && textos.map((txt, index) => (
                        <Accordion
                            key={index}
                            expanded={expanded === `painel${index}`}
                            onChange={() => setExpanded(old => old === `painel${index}` ? `` : `painel${index}`)}
                        >
                            <AccordionSummary aria-controls={`painel${index}d-content`} id={`panel${index}d-header`}>
                                <Typography component="span">{txt.tipo_paragrafo.toUpperCase()} {`{${txt.variavel}}`}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <InputLabel
                                    label="Texto"
                                    multiline
                                    rows={10}
                                    value={txt.paragrafo}
                                    onChange={e => hanleText(e.target.value, index)}
                                />
                                <Box display="flex" justifyContent="flex-end">
                                    <IconButton 
                                        aria-label="delete" 
                                        size="large" 
                                        color="error"
                                        onClick={() => handleDelete(txt.id_paragrafo)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Grid>

                <Grid container justifyContent="center" size={12} sx={{ mt: 4 }}>
                    <Button
                        variant="contained"
                        startIcon={<Save />}
                        color="success"
                        onClick={handleSaveTexts}
                    >
                        SALVAR TEXTOS
                    </Button>
                </Grid>
            </Grid>
        </Template>
    );
}